import { useMemo } from 'react';
import { getLabel, labels, Labels } from '../lib/labels';

export interface UseLabelsReturn {
  labels: Labels;
  getLabel: (path: string, fallback?: string) => string;
}

export function useLabels(): UseLabelsReturn {
  return useMemo(() => ({
    labels,
    getLabel,
  }), []);
}

// Utility hook for getting specific label sections
export function useLabelSection<T extends keyof Labels>(section: T): Labels[T] {
  return useMemo(() => labels[section], [section]);
}
